export const WORKORDER_PRIORITY_HIGH = 2;
export const WORKORDER_PRIORITY_MEDIUM = 1;
export const WORKORDER_PRIORITY_LOW = 0;

export const WORKORDER_STATUS_NEW = 0;
export const WORKORDER_STATUS_MAINTENANCE = 1;
export const WORKORDER_STATUS_OPERATION = 2;
export const WORKORDER_STATUS_COMPLETED = 3;
export const WORKORDER_STATUS_INPROGRESS = 1;
export const WORKORDER_STATUS_CLOSED = 2;

export const INVOICE_STATUS_NEW = 0;
export const INVOICE_STATUS_PAYMENTPENDING = 1;
export const INVOICE_STATUS_PAID = 2;
export const INVOICE_STATUS_OVERDUE = 3;

export const FORM_PUBLIC_STATUS = 'public';

export const CUSTOM_LOCATION = 1;
export const GLOBAL_LOCATION = 2;

export const TIME_BASED_SHIFT = 'time';
export const DROPDOWN_BASED_SHIFT = 'dropdown';
